<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{pump_status}}</h4>
                <p style="font-size: 12px">{{web_texts.partials.pump_status}}</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-plug fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{flow_pump}} m<sup>3</sup>/h</h4>
                <p style="font-size: 12px">{{web_texts.partials.flow_pump}}</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-compass fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-warning" style="min-height: 82px">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0" style="font-size: 155%;">{{counter_lecture}} m<sup>3</sup></h4>
                <p style="font-size: 12px">{{web_texts.partials.counter_lecture}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-dashboard fa-4x card-icon"></i>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card" :class="class_card_color"><!--:class="class_card_color"-->
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{prc_raft}} %</h4>
                <p style="font-size: 12px">{{web_texts.partials.vol_raft}} {{vol_raft}} m<sup>3</sup></p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-reorder fa-4x card-icon"></i>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.historical_pump_activations}}</span>
          </div>
          <div class="card-block">
            <div id="pot-act-gen-pump" style="height: 300px; width: 100%;"></div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.historical_low_level}}</span>
          </div>
          <div class="card-block">
            <div id="well-level" style="height: 300px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../../../translates/cat/Home';
  import trans_es from '../../../translates/es/Home';
  import constants from '../../../constants';
  import middleware from '../../../utilities/middlewares';
  import dateRanges from '../../../utilities/dates_intervals';
  import dataTransforms from '../../../utilities/data_transformers';

  export default {
    name: '',
    props: ['devices', 'master_dev'],
    data() {
      return {
        web_texts: { "electric_params": "Paràmetres Elèctrics", "generator": "Grup Electrogen", "pump_well": "Bomba-Bassa", "partials": {"historical_active_power_diary": "Històric diari potència activa","cos_phi_2": "Cosinus de phi φ", "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "current_power": "Pot. Actual", "status": "Estat", "current_active_power": "Potència Activa Instantània", "cos_phi": "Cosinus de Phi Instantani", "monthly_energy_consumed": "Històric anual d'energia consumida", "generator_status": "Estat Grup", "api_general": "Pot. General", "api_generator": "Pot. Grup", "current_tension": "Tensió actual", "active_power": "Potència activa", "active_power_now": "Potència Activa Instantània", "active_reactive_energy": "Energia activa reactiva", "Cos_phi": "Cosinus de phi", "monthly_active_power": "Històric potencia activa mensual", "pump_status": "Estat Bomba", "flow_pump": "Cabal Bomba", "counter_lecture": "Lec. Comptador", "vol_raft": "Niv. Bassa", "historical_pump_activations": "Històric activacions bomba", "historical_low_level": "Històric nivell bassa" } },
        general: '',
        pump_status: 'S/D',
        flow_pump: '0',
        counter_lecture: 'S/D',
        prc_raft: 'S/D',
        vol_raft: 'S/D',
        class_card_color: 'card-success'
      }
    },
    created() {
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["home","pump"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);

      var out = this;
      this.system = JSON.parse(window.localStorage.getItem('system'));
      console.log("Created Pump");
      this.getGeneralGeneratorDevice();
      this.getPumpWellValues();

      var pump_interval = setInterval(function () {
        console.log("Interval Pump");
        var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));

        if (contr_rt[1] !== "pump") {
          console.log("Clear pump loop");
          clearInterval(pump_interval);
        }else {
          out.getPumpWellValues();
        }
      }, 5000);
    },
    mounted(){
      this.getMonthlyWellPercLevel()
    },
    methods: {
      getGeneralGeneratorDevice() {
        var devices = this.devices;
        for (var i = 0; i < devices.length; i++) {
          if (devices[i].name.indexOf("General") > 0) {
            this.general = devices[i];
            this.getMonthlyActivePowerGeneral();
          }
        }
      },
      getPumpWellValues() {
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: '[["' + this.master_dev.id + '", "R$EVE_E_Bomba_ON.ST", "R$CAL_LecturaComptador.M3", "R$CAL_NivellBassa.PERC", "R$CAL_NivellBassa.M3"]]'
        }).then((response) => {
          console.log(response.data)
          if(parseInt(response.data[0].value)===1){
            this.pump_status="ON"
          }else if(parseInt(response.data[0].value)===0){
            this.pump_status="OFF"
          }else {
            this.pump_status="S/D"
          }

          if(response.data[1].value==="-"){
            this.counter_lecture='S/D'
          }else {
            this.counter_lecture=Math.round(response.data[1].value*100)/100;
          }

          if(response.data[2].value==="-"){
            this.prc_raft='S/D'
          }else {
            this.prc_raft=Math.round(response.data[2].value*100)/100;
          }

          if(response.data[3].value==='-'){
            this.vol_raft="S/D"
          }else {
            this.vol_raft=Math.round(response.data[3].value*100)/100;
          }
        }, (response) => {
          console.log(response.data)
        });
      },
      getMonthlyActivePowerGeneral(){
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.general.id, "API"]]),
          date_range: dateRanges.currentMonthDaterange()
        }).then((response) => {
          this.printMonthlyActivePowerGeneral(dataTransforms.lineDataTransformCanvasJS(response.data, "line",["P. Activa"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      getMonthlyWellPercLevel() {
        axios.post(constants.ROOT_URL + '/api/v1/stored_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.master_dev.id, "R$CAL_NivellBassa.PERC"]]),
          date_range: dateRanges.currentMonthDaterange()
        }).then((response) => {
          this.printMonthlyRaftPerc(dataTransforms.lineDataTransformCanvasJS(response.data, "line", ["Nivell Bassa"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      printMonthlyActivePowerGeneral(data){
        try {
        //Better to construct options first and then pass it as a parameter
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX:{
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data  // random data
        };

        $("#pot-act-gen-pump").CanvasJSChart(options);
        }catch (e){
          console.log("Catch");
        }
      },
      printMonthlyRaftPerc(data) {
        try {
        //Better to construct options first and then pass it as a parameter
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "%"
          },
          data: data  // random data
        };

        $("#well-level").CanvasJSChart(options);
        }catch (e){
          console.log("Catch");
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// PumpStatus.vue?5afa70cd